<template>
  <div>
    <el-card class="login-form-layout">
      <el-form autoComplete="on"
               :model="loginForm"
               :rules="loginRules"
               ref="loginForm"
               label-position="left">
        <h2 class="login-title color-main">CoffeeBear</h2>
        <el-form-item prop="username">
          <el-input name="username"
                    type="text"
                    v-model="loginForm.username"
                    autoComplete="on"
                    placeholder="请输入用户名">
          <span slot="prefix">
            <svg-icon icon-class="user" class="color-main"></svg-icon>
          </span>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input name="password"
                    :type="pwdType"
                    @keyup.enter.native="handleLogin"
                    v-model="loginForm.password"
                    autoComplete="on"
                    placeholder="请输入密码">
          <span slot="prefix">
            <svg-icon icon-class="password" class="color-main"></svg-icon>
          </span>
            <span slot="suffix" @click="showPwd">
            <svg-icon :icon-class="eye" class="color-main"></svg-icon>
          </span>
          </el-input>
        </el-form-item>
        <el-form-item style="margin-bottom: 15px;text-align: left">
          <el-input style="width: 60%" name="code"
                    type="text"
                    v-model="loginForm.code"
                    autoComplete="on"
                    placeholder="请输入验证码"
                    @keyup.enter.native="handleLogin"></el-input>
          <img @click="onCode" style="width: 35%;height: 38px;vertical-align:middle;text-align: right" :src="loginForm.url" />
        </el-form-item>
        <el-form-item style="margin-bottom: 60px;text-align: center">
          <el-button style="width: 100%" type="primary" :loading="loading" @click.native.prevent="handleLogin">
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <img :src="login_center_bg" class="login-center-layout" Ondragstart="return false">

      <div style="font-size:12px;position:fixed;text-align:center;bottom:10px;margin:0 auto;width:100%;color: #5c6b77">
        Copyright © 2022 coffeebear.cn
        <a target="_blank" style="font-size:12px;color: #5c6b77" href="https://beian.miit.gov.cn/#/Integrated/index">辽ICP备2021013758号-1</a>
        <br/>
        沈阳市皓涵创新科技有限公司 version 2.0
      </div>
  </div>

</template>

<script>
  import {isvalidUsername} from '@/utils/validate';
  import {setSupport,getSupport,setCookie,getCookie} from '@/utils/support';
  import { removeTenant } from '@/utils/auth'
  import login_center_bg from '@/assets/images/login_bg.jpeg'

  export default {
    name: 'login',
    data() {
      const validateUsername = (rule, value, callback) => {
        if (!isvalidUsername(value)) {
          callback(new Error('请输入正确的用户名'))
        } else {
          callback()
        }
      };
      const validatePass = (rule, value, callback) => {
        if (value.length < 3) {
          callback(new Error('密码不能小于3位'))
        } else {
          callback()
        }
      };
      return {
        eye: 'eye',
        loginForm: {
          username: '',
          password: '',
          code: '',
          url: process.env.BASE_API + '/home/getImage'
        },
        loginRules: {
          username: [{required: true, trigger: 'blur', validator: validateUsername}],
          password: [{required: true, trigger: 'blur', validator: validatePass}]
        },
        loading: false,
        pwdType: 'password',
        login_center_bg,
        dialogVisible:false,
        supportDialogVisible:false
      }
    },
    created() {
      removeTenant();
      this.loginForm.username = getCookie("username");
      this.loginForm.password = getCookie("password");
      if(this.loginForm.username === undefined||this.loginForm.username==null||this.loginForm.username===''){
        this.loginForm.username = '';
      }
      if(this.loginForm.password === undefined||this.loginForm.password==null){
        this.loginForm.password = '';
      }
    },
    methods: {
      onCode() {
        this.loginForm.url = process.env.BASE_API + '/home/getImage?ts=' + new Date();
      },
      showPwd() {
        if (this.pwdType === 'password') {
          this.eye = 'eye-regular'
          this.pwdType = ''
        } else {
          this.eye = 'eye'
          this.pwdType = 'password'
        }
      },
      handleLogin() {
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            // let isSupport = getSupport();
            // if(isSupport===undefined||isSupport==null){
            //   this.dialogVisible =true;
            //   return;
            // }
            this.loading = true;
            this.$store.dispatch('Login', this.loginForm).then(() => {
              this.loading = false;
              setCookie("username",this.loginForm.username,15);
              setCookie("password",this.loginForm.password,15);
              this.$router.push({path: '/'})
            }).catch(() => {
              this.loading = false
              this.onCode()
            })
          } else {
            console.log('参数验证不合法！');
            return false
          }
        })
      },
      handleTry(){
        this.dialogVisible =true
      },
      dialogConfirm(){
        this.dialogVisible =false;
        setSupport(true);
      },
      dialogCancel(){
        this.dialogVisible = false;
        setSupport(false);
      }
    }
  }
</script>

<style scoped>
  .login-form-layout {
    border: 1px solid #0a0a0a;
    box-shadow: rgba(0, 0, 0, 0.5) 15px 14px 15px;
    position: absolute;
    background: #0a0a0a;
    opacity: 0.65;
    left: 0;
    right: 0;
    width: 80%;
    max-width:360px;
    margin: 13% 60% auto;
    border-top: 10px solid #0a0a0a;
  }
  @media screen and (max-width: 500px) {
   .login-form-layout{
     top: 13%;
     right: calc(50% - 180px);
    margin: 0 auto;
   }
}
  .login-title {
    text-align: center;
  }

  .login-center-layout {
    display:block;
    width:100%;
    height: 100vh;
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue